const BETA_FEATURE_LOCAL_STORAGE_KEY = "beta-feature";

let cachedBetaFeatureEnabled: boolean | null = null;

const readBetaFeatureEnabled = (): boolean =>
  typeof localStorage !== "undefined" &&
  localStorage.getItem(BETA_FEATURE_LOCAL_STORAGE_KEY) === "true";

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === BETA_FEATURE_LOCAL_STORAGE_KEY) {
      cachedBetaFeatureEnabled = null;
    }
  });
}

export const isBetaFeatureEnabled = (): boolean => {
  if (cachedBetaFeatureEnabled === null) {
    cachedBetaFeatureEnabled = readBetaFeatureEnabled();
  }
  return cachedBetaFeatureEnabled;
};

export const setBetaFeatureEnabled = (enabled: boolean): void => {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(BETA_FEATURE_LOCAL_STORAGE_KEY, String(enabled));
  cachedBetaFeatureEnabled = enabled;
};
